'use strict';
import * as $j_app$002eauth$002e$002dClient$002dSide$002dAuth$002dUser from "./app.auth.-Client-Side-Auth-User.js";
import * as $j_app$002edata$002e$002dApp$002dUser$002dEmail$0024 from "./app.data.-App-User-Email$.js";
import * as $j_app$002edata$002e$002dApp$002dUser$002dEmail$0024$002dGeneral$002dPractice from "./app.data.-App-User-Email$-General-Practice.js";
import * as $j_app$002edata$002e$002dApp$002dUser$002dEmail$0024$002dPharmacy from "./app.data.-App-User-Email$-Pharmacy.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_auth_ClientSideAuthUser$() {
}
export { $c_Lapp_auth_ClientSideAuthUser$ as $c_Lapp_auth_ClientSideAuthUser$ };
$c_Lapp_auth_ClientSideAuthUser$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_auth_ClientSideAuthUser$.prototype.constructor = $c_Lapp_auth_ClientSideAuthUser$;
/** @constructor */
function $h_Lapp_auth_ClientSideAuthUser$() {
}
export { $h_Lapp_auth_ClientSideAuthUser$ as $h_Lapp_auth_ClientSideAuthUser$ };
$h_Lapp_auth_ClientSideAuthUser$.prototype = $c_Lapp_auth_ClientSideAuthUser$.prototype;
$c_Lapp_auth_ClientSideAuthUser$.prototype.apply__s_Option__T__s_Option = (function(supabaseSession, email) {
  var this$1 = $j_app$002edata$002e$002dApp$002dUser$002dEmail$0024.$m_Lapp_data_AppUserEmail$().apply__T__s_util_Either(email).toOption__s_Option();
  if (this$1.isEmpty__Z()) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  } else {
    var x0 = this$1.get__O();
    if (supabaseSession.isEmpty__Z()) {
      var maybeSessionVar = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    } else {
      var x0$1 = supabaseSession.get__O();
      var maybeSessionVar = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_state_Var$().apply__O__Lcom_raquo_airstream_state_Var(x0$1));
    }
    matchResult15: {
      var $x_1;
      if ((x0 instanceof $j_app$002edata$002e$002dApp$002dUser$002dEmail$0024$002dGeneral$002dPractice.$c_Lapp_data_AppUserEmail$GeneralPractice)) {
        var x63 = x0.Lapp_data_AppUserEmail$GeneralPractice__f_email;
        var $x_1 = new $j_app$002eauth$002e$002dClient$002dSide$002dAuth$002dUser.$c_Lapp_auth_ClientSideAuthUser$GeneralPractice(x63, maybeSessionVar);
        break matchResult15;
      }
      if ((x0 instanceof $j_app$002edata$002e$002dApp$002dUser$002dEmail$0024$002dPharmacy.$c_Lapp_data_AppUserEmail$Pharmacy)) {
        var x60 = x0.Lapp_data_AppUserEmail$Pharmacy__f_email;
        var $x_1 = new $j_app$002eauth$002e$002dClient$002dSide$002dAuth$002dUser.$c_Lapp_auth_ClientSideAuthUser$Pharmacy(x60, maybeSessionVar);
        break matchResult15;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x0);
    }
    return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some($x_1);
  }
});
$c_Lapp_auth_ClientSideAuthUser$.prototype.forSupabase__Ltypings_supabaseAuthJs_distModuleLibTypesMod_Session__T__s_Option = (function(supabaseSession, email) {
  return this.apply__s_Option__T__s_Option(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(supabaseSession), email);
});
$c_Lapp_auth_ClientSideAuthUser$.prototype.splitAuth__Lcom_raquo_airstream_core_Signal__F2__F2__Lcom_raquo_airstream_core_Signal = (function(signal, onGP, onPharmacy) {
  var this$3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_split_SplitMatchOneMacros$();
  var project = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sr_AbstractFunction1_$$Lambda$70e1780b84463d18653aacefee3ab989ac625f28(((i) => {
    if ((i instanceof $j_app$002eauth$002e$002dClient$002dSide$002dAuth$002dUser.$c_Lapp_auth_ClientSideAuthUser$GeneralPractice)) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), 0, i);
    }
    if ((i instanceof $j_app$002eauth$002e$002dClient$002dSide$002dAuth$002dUser.$c_Lapp_auth_ClientSideAuthUser$Pharmacy)) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), 1, i);
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(i);
  }));
  var parentObservable = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcom_raquo_airstream_misc_MapSignal(), signal, project, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  var handlers = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O([onGP, onPharmacy]));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$p_Lcom_raquo_airstream_split_SplitMatchOneMacros$__toSplittableOneObservable__Lcom_raquo_airstream_core_BaseObservable__sci_Seq__Lcom_raquo_airstream_core_Observable(this$3, parentObservable, handlers);
});
var $d_Lapp_auth_ClientSideAuthUser$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_auth_ClientSideAuthUser$, "app.auth.ClientSideAuthUser$", ({
  Lapp_auth_ClientSideAuthUser$: 1
}));
export { $d_Lapp_auth_ClientSideAuthUser$ as $d_Lapp_auth_ClientSideAuthUser$ };
var $n_Lapp_auth_ClientSideAuthUser$;
function $m_Lapp_auth_ClientSideAuthUser$() {
  if ((!$n_Lapp_auth_ClientSideAuthUser$)) {
    $n_Lapp_auth_ClientSideAuthUser$ = new $c_Lapp_auth_ClientSideAuthUser$();
  }
  return $n_Lapp_auth_ClientSideAuthUser$;
}
export { $m_Lapp_auth_ClientSideAuthUser$ as $m_Lapp_auth_ClientSideAuthUser$ };
//# sourceMappingURL=app.auth.-Client-Side-Auth-User$.js.map
